import { Grid, Space, Table } from "../components/Layout";
import { Media, Title, Texts, Button } from "../components/Object";
import { Head, News } from "../components/Project";
import { List, NavList } from "../components/Project/Merit";
import { HashLink } from "react-router-hash-link";
import { Scroll } from "../components/Animation";
import Get from '../components/Post/Get';
import { useDocumentLoadCompleted } from "../components/Hooks";

const Company = () => {
  // const googleMap = `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3292.511993755332!2d135.32596367718375!3d34.388330199906974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000c9ad977c3285%3A0xeee1eea850823867!2z44CSNTk4LTAwMjEg5aSn6Ziq5bqc5rOJ5L2Q6YeO5biC5pel5qC56YeO77yT77yX77yQ77yZ4oiS77yR!5e0!3m2!1sja!2sjp!4v1684745003431!5m2!1sja!2sjp" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`;
  const corpAddText = [
    [
      '人は人財',
      '外国人実習生の斡旋<br>実習期間において、 言葉・文化・考え方が違う中で共に働き、指導・教育していく中でお互いに人間力を高めていく。'
    ],
    [
      '物は物財',
      '協同組合の本来の姿である、組合員のネットワークを活用し、物を交流させる。'
    ],
    [
      '金は財貨',
      '組合員へ迅速に活用できる 「助成金・補助金等」を申請の段階からお手伝いします'
    ],
  ];

  const isLoaded = useDocumentLoadCompleted();

  return (
    <>

      <Head slug="page-company"></Head>
      <Space size={["80px", "64px"]} />

      <Space size={['0 0 120px', '0 0 80px']}>
        <Message />
      </Space>


      <div className="l-row" data-state="right">
        <div className="p-box__wrap--gray">
          <Space size={['100px', '72px']} />
          <div className="l-row l-row--normal">
            <Title slug="corporate-philosophy"></Title>
            <Space size={['48px 0 0', '32px 0 0']}>
              <Space size={['0 0 32px', '0 0 24px']}>
                <Texts slug="company/corp"></Texts>
              </Space>
              <ul className="c-grid__wrap--repeat-3">
                {corpAddText.map((lists, index) => (
                  <Scroll>
                    <li className="c-grid__items--square" data-state="white">
                      <div className="p-title__wrap--en">
                        <Texts slug={`company/label${index}`} addText={lists[0]}></Texts>
                      </div>
                      <Space size={['32px 0 0', '24px 0 0']}>
                        <Texts slug={`company/value${index}`} class="c-text--med" addText={lists[1]}></Texts>
                      </Space>
                    </li>
                  </Scroll>
                ))}
              </ul>
            </Space>
          </div>
          <Space size={['100px', '72px']} />
        </div>
      </div>

      <Space size={['120px 0 0', '80px 0 0']}>

        <Information />

      </Space>

      <Space size={["120px 0 15px", "80px 0 12px"]}>
        <News />
      </Space>
    </>
  )
}


const Message = () => {
  return (
    <>
      <div className="l-row l-row--normal" data-state="min">
        <div>
          <Title slug="message-company" type="center"></Title>
          <Space size={['40px 0 24px', '32px 0 16px']}>
            <Texts slug="company/message" class="c-text--med"></Texts>
          </Space>
          <Texts slug="company/bottom"></Texts>
        </div>
      </div>
    </>
  );
};


const Information = () => {
  const args = {
    postType: "company",
    perPage: 20,
    page: 1,
  };

  const isLoaded = useDocumentLoadCompleted();
  const posts = Get(args);

  // const addText = [
  //   ["<b>組合名</b>", "結協同組合"],
  //   ["<b>代表理事</b>", "中井 祐次"],
  //   ["<b>所在地</b>", "〒668-0256<br>兵庫県豊岡市出石町小人230"],
  //   ["<b>TEL</b>", "0796-34-9337"],
  //   ["<b>FAX</b>", "0796-34-9338"],
  //   ["<b>Mail</b>", "musubu@clock.ocn.ne.jp"],
  //   ["<b>設立年月日</b>", "2022年11月28日"],
  //   [
  //     "<b>事業内容</b>",
  //     "外国人実習生共同受入事業<br>損害保険代理業<br>経営コンサルタント業<br>不動産紹介及び賃貸業<br>補助金等申請サポート",
  //   ],
  //   ["<b>従業員数</b>", "7名"],
  //   // ["<b>組合許可番号</b>", "待特定監理事業  許 2208000173"],
  //   // ["<b>組合許可番号</b>", " "],
  //   ["<b>監理団体許可番号</b>", "特定監理事業　許2208000173"],
  //   ["<b>登録支援機関番号</b>", "23登ー008727"],
  //   ["<b>受入可能国</b>", "ベトナム・ラオス・ミャンマー・インドネシア・カンボジア"],
  // ];
  // 
  let items = [];

  const Item = (props) => {
    return (
      <li className="c-table__items">
        <div className="c-table__items--left">
          <Texts class="" slug={`information-company/label0`} addText={props.post.title.rendered} />
        </div>
        <div className="c-table__items--right">
          <Texts slug={`information-company/value0`} addText={props.post.content.rendered} />
        </div>
      </li>
    )
  }

  const Loading = (props) => {
    return (
      <>
        <p>Loading...</p>
      </>
    );
  };

  if (posts && isLoaded) {
    // post情報取得後
    items = posts.map((post, key) => {
      return <Item key={key} post={post} />;
    });
  } else {
    // post情報取得中
    items.push(<Loading></Loading>);
  }

  return (
    <>
      <div className="l-row l-row--normal" data-state="min">
        <Title slug="information-company" type="center"></Title>
        <Space size={["48px", "32px"]}></Space>

        <ul className="c-table__list">
          {items}
        </ul>
        {/* <Table slug="information-company" len="11" addText={addText}></Table> */}
      </div>
    </>
  );

};

export default Company;